import { GridApi } from 'ag-grid-community';
import { uniqBy } from 'lodash';

import { SelectableFilterOption }
  from '@/components/common/TableGrid/CustomComponents/AgGridSelectableFilter/AgGridSelectableFilter';
import { BillingCycleOutput } from '@/graphql/contracts/_generated_/contracts';
import { BillingCycleStatusFormatted } from '@/config/statuses.config';

const getRowsData = <TData = any>(api: GridApi) => {
  const rowsData: TData[] = [];
  api.forEachNode((node) => rowsData.push(node.data));
  return rowsData;
};

export class BillingCycleFilterOptions {
  static getStockCodeFilterOptions(api: GridApi): SelectableFilterOption[] {
    const billingCycles = getRowsData<BillingCycleOutput>(api);
    const options = billingCycles.filter(bc => !!bc && !!bc.stockCode).map((el) => ({
      text: `${el.stockCode} - ${el.stockName}`,
      returnValue: el.stockCode!
    }));

    return uniqBy(options, 'returnValue');
  }

  static getProcessingStatusFilterOptions(api: GridApi): SelectableFilterOption[] {
    const billingCycles = getRowsData<BillingCycleOutput>(api);
    const options = billingCycles.filter(bc => !!bc && !!bc.processingStatus).map((el) => ({
      text: BillingCycleStatusFormatted[el.processingStatus!],
      returnValue: el.processingStatus!
    }));

    return uniqBy(options, 'returnValue');
  }

  static getStatusReasonFilterOptions(api: GridApi): SelectableFilterOption[] {
    const billingCycles = getRowsData<BillingCycleOutput>(api);
    const options = billingCycles.filter(bc => !!bc && !!bc.statusReason).map((el) => ({
      text: el.statusReason!,
      returnValue: el.statusReason!
    }));

    return uniqBy(options, 'returnValue');
  }

  static getConsolidationCriteriaCodeFilterOptions(api: GridApi): SelectableFilterOption[] {
    const billingCycles = getRowsData<BillingCycleOutput>(api);
    const options = billingCycles.filter(bc => !!bc && !!bc.consolidationCriteriaCode).map((el) => ({
      text: el.consolidationCriteriaCode!,
      returnValue: el.consolidationCriteriaCode!
    }));

    return uniqBy(options, 'returnValue');
  }

  static getContractLineIDFilterOptions(api: GridApi): SelectableFilterOption[] {
    const billingCycles = getRowsData<BillingCycleOutput>(api);
    const options = billingCycles.filter(bc => !!bc && !!bc.contractLineID).map((el) => ({
      text: el.contractLineID!,
      returnValue: el.contractLineID!
    }));

    return uniqBy(options, 'returnValue');
  }
}
